import React from 'react';
import {formatNumber, formatNumberAtDecimal} from "../../../lib/formatting";
import PropTypes from 'prop-types';

function DataComponent(props) {
    const {yieldData} = props;

    return (
        <div className="component datacomponent">
            <div className="content-block">
                <p className="value-display">
                    <span
                        className="value">{formatNumberAtDecimal(yieldData.Yield, yieldData.Yield > 1000 ? 0 : 1)}</span>
                </p>
            </div>
            <hr/>
            <div className="title">
                <h2>
                    <span className='disable-text-transform'>kWh</span> opgewekt
                </h2>
            </div>
        </div>
    )
}

DataComponent.propTypes = {
    title: PropTypes.string,
    yieldData: PropTypes.any,
    // unit: PropTypes.any,
};

DataComponent.defaultProps = {
    power: 0,
};

export default DataComponent;
